import { SitemapEntry } from '../sitemap.types';
import { ADMIN_MANAGEMENT_SITEMAP_ENTRIES } from './sitemap.admin-management.catalog';
import { ADMIN_OPERATIONS_SITEMAP_ENTRIES } from './sitemap.admin-operations.catalog';
import { ADMIN_STUDENT_SITEMAP_ENTRIES } from './sitemap.admin-students.catalog';

// This catalog is intentionally isolated from normal feature and release work.
// Agents may edit it only during an explicitly requested sitemap update run.
export const SITEMAP_CATALOG = [
	...ADMIN_STUDENT_SITEMAP_ENTRIES,
	...ADMIN_MANAGEMENT_SITEMAP_ENTRIES,
	...ADMIN_OPERATIONS_SITEMAP_ENTRIES,
	{
		id: 'view-student-dashboard',
		title: 'View the student dashboard',
		guidance:
			'See weekly objectives, calendar items, and current expectations.',
		href: '/student-app/home',
		application: 'student',
		audiences: ['user'],
		categoryPath: ['Dashboard', 'Overview'],
		searchTerms: ['home', 'weekly objectives', 'expectations', 'calendar'],
	},
	{
		id: 'review-course-history',
		title: 'Review course history',
		guidance: 'Review current and previous courses for the active student.',
		href: '/student-app/courses/history',
		application: 'student',
		audiences: ['user'],
		categoryPath: ['Courses', 'History'],
		searchTerms: ['past courses', 'previous courses', 'current courses'],
	},
	{
		id: 'read-announcements',
		title: 'Read announcements',
		guidance:
			'Read important and general announcements from the student’s team.',
		href: '/student-app/announcements',
		application: 'student',
		audiences: ['user'],
		categoryPath: ['Communication', 'Announcements'],
		searchTerms: ['messages', 'news', 'important announcement', 'general'],
	},
	{
		id: 'review-weekly-progress',
		title: 'Review weekly progress',
		guidance: 'Review weekly activities and progress in Wonder.',
		href: '/wonder/weekly-progress',
		application: 'wonder',
		audiences: ['user'],
		categoryPath: ['Progress', 'Weekly'],
		searchTerms: ['activities', 'weekly activities', 'progress report'],
	},
	{
		id: 'open-wonder-calendar',
		title: 'Open the Wonder calendar',
		guidance: 'View upcoming classes, meetings, and scheduled activities.',
		href: '/wonder/calendar',
		application: 'wonder',
		audiences: ['user'],
		categoryPath: ['Schedule', 'Calendar'],
		searchTerms: ['schedule', 'classes', 'meetings', 'events'],
	},
	{
		id: 'get-wonder-support',
		title: 'Get Wonder support',
		guidance: 'Find support contacts and available ways to ask for help.',
		href: '/wonder/support',
		application: 'wonder',
		audiences: ['user'],
		categoryPath: ['Support'],
		searchTerms: ['help', 'contact', 'assistance'],
	},
] as const satisfies readonly SitemapEntry[];
